module.exports = new __parcel__URL__("second-place.cbda4f5b.svg").toString();